<template>
  <section class="tab-body">
    <p class="tab-description">
      <span class="bold-font">Pass Information</span>
    </p>

    <PassViewDetail
      :isOrganizer="isOrganizer"
      :passDetail="passDetail"
      :agreementCategories="agreementCategories"
      :userDetailCategories="userDetailCategories"
      :onClickDeactivate="onClickDeactivate"
      :onClickEdit="onClickEdit" />
  </section>
</template>

<script>
import PassViewDetail from '@/components/passes/PassViewDetail'

export default {
  components: {
    PassViewDetail
  },
  data() {
    return {

    }
  },
  props: {
    isOrganizer: String,
    passDetail: Object,
    agreementCategories: Array,
    userDetailCategories: Array,
    onClickDeactivate: Function,
    onClickEdit: Function
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabview/PassDetailTab.vue